import React, { useState, useEffect } from "react";

export default function ResendCode(props: any) {
  const { initialSeconds = 0 } = props;
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        clearInterval(myInterval);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  const handleResendCode = () => {
    if (props.resendCallback) {
      props.resendCallback();
    }
    setSeconds(60);
  };
  return seconds === 0 ? (
    <span
      className="cursor-pointer font-normal text-[#717272] hover:text-[#5f6060]"
      onClick={handleResendCode}
    >
      Didn't get otp? Click to resend
    </span>
  ) : (
    <span className="font-medium text-blue-600 hover:text-blue-700">
      Try after <b>{seconds}</b> seconds
    </span>
  );
}
